import { tweekAppLoader, tweekFlashMessage, tweekInfoPopup, tweekProceedLoginToTheApp, tweekWidgetInfoModal } from "../Reducers/appConfigReducer";


export const setRenderLoader = (isVisible, loaderMessage = '') => tweekAppLoader({ isVisible, loaderMessage });

export const setRenderFlashMessage = (isVisible, messageConfig) => tweekFlashMessage({isVisible, messageConfig});

export const setRenderInfoPopup = (isVisible, popupConfig) => tweekInfoPopup({isVisible, popupConfig});


export const setProceedLoginToTheApp = (init, guestDetails={}) => tweekProceedLoginToTheApp({init, guestDetails});

export const setRenderWidgetInfoModal = (isVisible, modalData) => tweekWidgetInfoModal({isVisible, modalData});